export const numberFormatter = (val: number) =>
    Intl.NumberFormat('en-IN', {
        notation: 'compact',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    })
        .format(val || 0)
        .replace('T', 'K')
